<h2>Student</h2>
<app-vca-filter [pageId]="pageId" [userInfos]="userInfos" [modes]="modes" [platformInfos]="platformInfos" [hasSearchKey]="true" (filterDataOutputEvent)="sendFilterData($event)">
</app-vca-filter>
<app-student-manager [userInfos]="userInfos" [filterData]="filterData" [platformInfos]="platformInfos" (inProgress)="setProgress($event)"></app-student-manager>

